import React from 'react';
import useNamedCohortInfo from './useNamedCohortInfo';
import NamedCohortInfo from '../NamedCohortInfo';
import { INamedCohortFetchProps } from '../../types';
import BuilderInfoLoader from '../../BuilderInfoLoader';

export default ({ kind, cohortId }: INamedCohortFetchProps) => {
  const { loading, cohort } = useNamedCohortInfo(cohortId);

  if (!cohort || loading) {
    return <BuilderInfoLoader />;
  }

  return <NamedCohortInfo kind={kind} cohort={cohort} fetched={true} />;
};
